/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { IObrienTeamContainerViewProps } from './obrien-team-container';




export const ObrienTeamContainerView: React.FC<IObrienTeamContainerViewProps> = props => {

    const { 
        row1categories,
        Row1List,
        Row1ListItem
    
    } = props;

    
    
    return (
       
            <>
            {row1categories ? (
            <div className='ob-team-container'>
                <Module {...Row1List}>
                    { row1categories.map((row1category: ReactNode, index: number) => {
                        return (
                        
                            <Node {...Row1ListItem} key={index}>
                                {row1category}
                            </Node>
                        
                        );
                    })}
                </Module>
            </div>
            ) : null}
            </>
            
    );
};

export default ObrienTeamContainerView;
